module.exports = __webpack_public_path__ + "img/foodie-l.3e152938.png";